import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { 
    Modal, ModalHeader, ModalBody, ModalFooter,
    Label, Input, Button, Table, Alert,
    Form, FormFeedback
} from "reactstrap";

import Dropzone from "react-dropzone";
import Dragula from 'react-dragula';
import { v4 as uuidv4 } from 'uuid';

import { useFormik } from "formik";

import { addVehicle, updateVehicle } from "../../../slices/thunks";
import { enginePower, transmissions, fuelTypes, engineTypes, manufacturers, models, bodyTypeData, paymentStatus} from "../../../common/data/olxCategories";

import { vehicleInit, vehicleValidationSchema, parseVehicle } from '../../../models/vehicle';
import { years } from "../../../common/data/allYearLists";

const VehicleModal = ({show, onCloseClick, vehicleDetails, isEdit}) => {
    const dispatch = useDispatch();

    const user = JSON.parse(sessionStorage.getItem("authUser"));
    const isAdmin = user.role == "Admin" ? true : false;
    
    const[isBatchMode, setIsBatchMode] = useState(false);
    const [files, setFiles] = useState([]);

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: !isEdit ? vehicleInit : parseVehicle(vehicleDetails),
        validationSchema: vehicleValidationSchema,
        onSubmit: (values) => {
            let vehicle = {
                vin: values.vin,
                productionYear: values.productionYear,
                mileage: values.mileage,
                transmission: values.transmission,
                brand: values.brand,
                model: values.model,
                engine: values.engine,
                engineFuel: values.engineFuel,
                enginePower: values.enginePower,
                engineTag: values.engineTag,
                bodyType: values.bodyType,
                color: values.color,
                purchasePrice: isAdmin ? values.purchasePrice : null,
                taxPrice: isAdmin ? values.taxPrice : null,
                sellerName: isAdmin ? values.sellerName : null,
                taxerName: isAdmin ? values.taxerName : null,
                isPaid: isAdmin ? values.isPaid == 1 : null,
                isTaxPaid: isAdmin ? values.isTaxPaid == 1 : null,
                description: values.description,                
            };
            if (isEdit) {
                vehicle = {
                    ...vehicle, 
                    id: vehicleDetails.id, 
                    displayId: vehicleDetails.displayId,
                    images: vehicleDetails.images
                };              
                dispatch(updateVehicle(vehicle));
            }
            else {
                let images = [];
                for(var i = 0; i < rows.length; i++){
                    let file = files.find(f => f.id == rows[i].id);
                    file.index = i+1;
                    images.push(file);
                }
                vehicle = {
                    ...vehicle,
                    images: images
                };                
                dispatch(addVehicle(vehicle));
            }
            handleOnCloseClick();
        }
    });

    const handleFormSubmit = (e) => {
        e.preventDefault();
        validation.handleSubmit();
        return false;
    };

    const handleOnCloseClick = () => {
        if(!isBatchMode){
            validation.resetForm();
        }
        setFiles([]);
        onCloseClick();
    };
    function handleAcceptedFiles(uploadedFiles) {  
        let i = files.length; 
        uploadedFiles.map(file => {
            i++;
            Object.assign(file, {
                preview: URL.createObjectURL(file),
                id: uuidv4(),
                index: i
            })
        });
        setFiles([...files, ...uploadedFiles]);
    }
    const deleteFile = (file) => {
        const modifiedFileList = files.filter(item => item.id != file.id);
        let i = 0;
        modifiedFileList.forEach(item => {
            i++;
            item.index = i;
        })
        setFiles(modifiedFileList);
    }

    var container = document.getElementById("image-container");
    var rows = !container ? [] : container.children || [];
    var nodeListForEach = function (array, callback, scope) {
        for (var i = 0; i < array.length; i++) {
            callback.call(scope, i, array[i]);
        }
    };
    
    var sortableTable = Dragula([container]);
        sortableTable.on('dragend', function() {
        nodeListForEach(rows, function (index, row) {
            row.dataset.rowPosition = index + 1;
        });
    });

    let vehicleName = "";
    if (isEdit) {
        const brand = manufacturers.find(m => m.value === vehicleDetails.brand);  
        const model = models.find(b => b.parentValue === brand.value && b.value === vehicleDetails.model);
        vehicleName = brand.label + " " + model.label;
    }

    return (
        <Modal id="vehicleModal" isOpen={show} toggle={handleOnCloseClick} centered backdrop="static">
            <ModalHeader className="modal-title" toggle={handleOnCloseClick}>
                {!isEdit ? "Dodaj novo vozilo" : "Izmjene za: " + vehicleName}
            </ModalHeader>
            <Form className="tablelist-form" onSubmit={(e) => {handleFormSubmit(e)}}>
            <ModalBody>
                <div className="row m-3">
                    <div className="form-check form-switch">                        
                        <Input name="batchMode" className="form-check-input" type="switch" checked={isBatchMode} onChange={() => {setIsBatchMode(!isBatchMode)}}/>
                        <Label className="form-check-label">Sačuvaj podatke za sljedeći unos?</Label>
                    </div>
                </div>
                    {/* BROJ ŠASIJE - GODINA*/}
                    <div className="row gy-4 mb-3">                    
                        <div className="col-md-8">
                            <Input name="vin" type="text" className="form-control"
                                placeholder="Broj šasije"                          
                                validate={{ required: { value: true }}}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.vin || ""}
                                invalid={validation.touched.vin && validation.errors.vin ? true : false}
                            />
                            {validation.touched.vin && validation.errors.vin ? (<FormFeedback type="invalid">{validation.errors.vin}</FormFeedback>) : null}
                        </div>
                        <div className="col-md-4">
                            <Input name="productionYear" type="select" className="form-select"
                                placeholder="Godište"                            
                                validate={{ required: { value: true }}}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.productionYear || ""}
                                invalid={validation.touched.productionYear && validation.errors.productionYear ? true : false}
                            >
                                {years.map(year => (<option value={year.value} key={year.value}>{year.label}</option>))}
                            </Input>
                            {validation.touched.productionYear && validation.errors.productionYear ? (<FormFeedback type="invalid">{validation.errors.productionYear}</FormFeedback>) : null}
                        </div>
                    </div>
                    {/* KILOMETRAŽA - TRANSMISIJA*/}
                    <div className="row gy-4 mb-3">                    
                        <div className="col-md-6">
                            <Input name="mileage" type="number" className="form-control"
                                placeholder="Kilometraža"                          
                                validate={{ required: { value: true }}}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.mileage || ""}
                                invalid={validation.touched.mileage && validation.errors.mileage ? true : false}
                            />
                            {validation.touched.mileage && validation.errors.mileage ? (<FormFeedback type="invalid">{validation.errors.mileage}</FormFeedback>) : null}
                        </div>
                        <div className="col-md-6">
                            <Input name="transmission" type="select" className="form-select"                         
                                validate={{ required: { value: true }}}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.transmission || ""}
                                invalid={validation.touched.transmission && validation.errors.transmission ? true : false }
                            >
                                {transmissions.map(item => (<option value={item.value} key={item.value}>{item.label}</option>))}
                            </Input>
                            {validation.touched.transmission && validation.errors.transmission ? (<FormFeedback type="invalid">{validation.errors.transmission}</FormFeedback>) : null}
                        </div>
                    </div>
                    {/* BRAND - MODEL */}
                    <div className="row gy-4 mb-3">
                        <div className="col-md-6">
                            <Input name="brand" type="select" className="form-select"                           
                                validate={{ required: { value: true }}}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.brand || ""}
                                invalid={validation.touched.brand && validation.errors.brand ? true : false}
                            >
                                {manufacturers.map(manufacturer => (<option value={manufacturer.value} key={manufacturer.value}>{manufacturer.label}</option>))}
                            </Input>
                            {validation.touched.brand && validation.errors.brand ? (<FormFeedback type="invalid">{validation.errors.brand}</FormFeedback>) : null}
                        </div>
                        <div className="col-md-6">
                            <Input name="model" type="select" className="form-select"                          
                                validate={{ required: { value: true }}}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.model || ""}
                                invalid={validation.touched.model && validation.errors.model ? true : false}
                            >
                                {models.filter(model => model.parentValue == validation.values.brand || model.parentValue == -1)
                                    .map(manufacturer => (<option value={manufacturer.value} key={manufacturer.value}>{manufacturer.label}</option>))}
                            </Input>
                            {validation.touched.model && validation.errors.model ? (<FormFeedback type="invalid">{validation.errors.model}</FormFeedback>) : null}
                        </div>     
                    </div>
                    {/* MOTOR - GORIVO */}
                    <div className="row gy-4 mb-3">
                        <div className="col-md-6">
                            <Input name="engine" type="select" className="form-select"
                                validate={{ required: { value: true }}}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.engine || ""}
                                invalid={validation.touched.engine && validation.errors.engine ? true : false}
                            >
                                {enginePower.map(item => (<option value={item.value} key={item.value}>{item.label}</option>))}
                            </Input>
                            {validation.touched.engine && validation.errors.engine ? (<FormFeedback type="invalid">{validation.errors.engine}</FormFeedback>) : null}
                        </div>
                        <div className="col-md-6">
                            <Input name="engineFuel" type="select" className="form-select"
                                validate={{ required: { value: true }}}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.engineFuel || ""}
                                invalid={validation.touched.engineFuel && validation.errors.engineFuel ? true : false}
                            >
                                {fuelTypes.map(fuelType => (<option value={fuelType.value} key={fuelType.value}>{fuelType.label}</option>))}
                            </Input>
                            {validation.touched.engineFuel && validation.errors.engineFuel ? (<FormFeedback type="invalid">{validation.errors.engineFuel}</FormFeedback>) : null}
                        </div>                        
                    </div>
                    {/* SNAGA - OZNAKA */}
                    <div className="row gy-4 mb-3">
                        <div className="col-md-6">
                            <Input name="enginePower" type="number" className="form-control"
                                placeholder="Snaga [kW]"
                                validate={{required: { value: true }}}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.enginePower || ""}
                                invalid={validation.touched.enginePower && validation.errors.enginePower ? true : false}
                            />
                            {validation.touched.enginePower && validation.errors.enginePower ? (<FormFeedback type="invalid">{validation.errors.enginePower}</FormFeedback>) : null}
                        </div>
                        <div className="col-md-6">
                            <Input name="engineTag" type="select" className="form-select"                         
                                validate={{required: { value: true }}}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.engineTag || ""}
                                invalid={validation.touched.engineTag &&  validation.errors.engineTag ? true : false}
                            >
                                {engineTypes.map(item => (<option value={item.value} key={item.value}>{item.label}</option>))}
                            </Input>
                            {validation.touched.engineTag && validation.errors.engineTag ? (<FormFeedback type="invalid">{validation.errors.engineTag}</FormFeedback>) : null}
                        </div>
                    </div>
                    {/* VRSTA - BOJA */}
                    <div className="row gy-4 mb-3">
                        <div className="col-md-6">
                            <Input name="bodyType" type="select" className="form-select"                         
                                validate={{required: { value: true }}}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.bodyType || ""}
                                invalid={validation.touched.bodyType && validation.errors.bodyType ? true : false}
                            >
                                {bodyTypeData.map(item => (<option value={item.value} key={item.value}>{item.label}</option>))}
                            </Input>
                            {validation.touched.bodyType && validation.errors.bodyType ? (<FormFeedback type="invalid">{validation.errors.bodyType}</FormFeedback>) : null}
                        </div>
                        <div className="col-md-6">
                            <Input name="color" type="text" className="form-control"
                                placeholder="Unesite boju vozila"                          
                                validate={{ required: { value: true }}}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.color || ""}
                                invalid={validation.touched.color && validation.errors.color ? true : false}
                            />
                            {validation.touched.color && validation.errors.color ? (<FormFeedback type="invalid">{validation.errors.color}</FormFeedback>) : null}
                        </div>
                    </div>
                    {/* FINANSIJE */}
                    {isAdmin && (
                        <div>
                            <div className="row gy-4 mb-3">
                                <div className="col-md-4">
                                    <Input name="purchasePrice" type="number" className="form-control"
                                        placeholder="Cijena/Transport"
                                        validate={{ required: { value: isAdmin }, }}
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.purchasePrice || ""}
                                        invalid={validation.touched.purchasePrice && validation.errors.purchasePrice ? true : false}
                                    />
                                    {validation.touched.purchasePrice && validation.errors.purchasePrice ? (<FormFeedback type="invalid">{validation.errors.purchasePrice}</FormFeedback>) : null}
                                </div>
                                <div className="col-md-4">
                                    <Input name="sellerName" type="text" className="form-control"
                                        placeholder="Dobavljač"
                                        validate={{ required: { value: isAdmin }, }}
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.sellerName || ""}
                                        invalid={validation.touched.sellerName && validation.errors.sellerName ? true : false}
                                    />
                                    {validation.touched.sellerName && validation.errors.sellerName ? (<FormFeedback type="invalid">{validation.errors.sellerName}</FormFeedback>) : null}
                                </div>                                
                                <div className="col-md-4">
                                    <Input name="isPaid" type="select" className="form-select"
                                        validate={{ required: { value: isAdmin }}}
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.isPaid || ""}
                                        invalid={validation.touched.isPaid && validation.errors.isPaid ? true : false}
                                    >
                                        {paymentStatus.map(item => (<option value={item.value} key={item.value}>{item.label}</option>))}
                                    </Input>
                                </div>
                            </div>
                            <div className="row gy-4 mb-3">
                                <div className="col-md-4">
                                    <Input name="taxPrice" type="number" className="form-control"
                                        placeholder="Carina/Porez"
                                        validate={{ required: { value: isAdmin }}}
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.taxPrice || ""}
                                        invalid={validation.touched.taxPrice &&validation.errors.taxPrice? true: false}
                                    />
                                    {validation.touched.taxPrice && validation.errors.taxPrice ? (<FormFeedback type="invalid">{validation.errors.taxPrice}</FormFeedback>) : null}
                                </div>
                                <div className="col-md-4">
                                    <Input name="taxerName" type="text" className="form-control"
                                        placeholder="Poreznik"
                                        validate={{ required: { value: isAdmin }}}
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.taxerName || ""}
                                        invalid={ validation.touched.taxerName && validation.errors.taxerName ? true : false }
                                    />
                                    {validation.touched.taxerName && validation.errors.taxerName ? (<FormFeedback type="invalid">{validation.errors.taxerName}</FormFeedback>) : null}
                                </div>
                                <div className="col-md-4">
                                    <Input name="isTaxPaid" type="select" className="form-select"
                                        validate={{ required: { value: isAdmin }}}
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.isTaxPaid || ""}
                                        invalid={validation.touched.isTaxPaid && validation.errors.isTaxPaid ? true : false}
                                    >
                                        {paymentStatus.map(item => (<option value={item.value} key={item.value}>{item.label}</option>))}
                                    </Input>
                                </div>
                            </div>                      
                        </div>
                    )}
                <div className="mb-3">
                    <Input name="description" type="textarea" className="form-control"
                        placeholder="Opis"                      
                        validate={{required: { value: false }}}
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.description}
                        invalid={validation.touched.description && validation.errors.description ? true : false}
                    />
                </div>
                {!isEdit && !(files.length > 0) && (<Alert color="danger" className="text-center fs-20">Morate dodati bar jednu sliku!</Alert>)}
                {!isEdit && files.length > 10 && (<Alert color="danger" className="text-center fs-20">Dodali ste {files.length} slika, što je više od 10 slika.</Alert>)}
                {!isEdit && (
                    <div>
                        <Dropzone onDrop={acceptedFiles => {handleAcceptedFiles(acceptedFiles)}}>
                            {({ getRootProps, getInputProps }) => (
                                <div className="dropzone dz-clickable" {...getRootProps()}>
                                    <input {...getInputProps()} />
                                    <div className="dz-message needsclick">
                                        <i className="display-5 text-muted ri-upload-cloud-2-fill" />
                                        <p>Drop files here or click to upload.</p>
                                    </div>
                                </div>
                            )}
                        </Dropzone>
                        <div id="file-previews" className="list-unstyled mb-0">
                            <div className="table-responsive mb-1">
                                <Table className="align-middle table table-borderless">                        
                                    <tbody id="image-container">{files.map(f => {
                                        return (
                                            <tr id={f.id} key={f.id} className="dz-processing dz-image-preview dz-success dz-complete">                                
                                                <td>
                                                    <img src={f.preview} alt={f.name} className="avatar-md rounded me-2" data-dz-thumbnail=""/>
                                                    <span className="text-muted fw-bold">{f.name}</span>
                                                </td>
                                                <td>
                                                    <button className="btn btn-sm btn-soft-danger remove-list" onClick={() => deleteFile(f)}>
                                                        <i className="ri-delete-bin-5-fill align-bottom"/>
                                                    </button>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                    </tbody>
                                </Table>
                            </div>
                        </div> 
                    </div>
                )}
            </ModalBody>
            <ModalFooter>
                <div className="hstack gap-2 justify-content-end">
                    <Button type="button" color="dark" outline onClick={() => {handleOnCloseClick()}}>Zatvori</Button>
                    {(!isEdit && (files.length > 0 && files.length < 11) || isEdit) && (<Button color="success" outline type="submit">{isEdit ? "Ažuriraj podatke" : "Dodaj novo vozilo"}</Button>)}
                </div>
            </ModalFooter>
            </Form>
        </Modal>
    );    
};

export default VehicleModal;